// data test
export const USER_ADMIN_TABS = "user-admin-tabs";
export const RESERVED_LICENSES_BUTTON = "test-reserved-licenses-button";
export const RENAME_WORKSPACE_BUTTON = "test-rename-workspace-button";
export const DELETE_WORKSPACE_BUTTON = "test-delete-workspace-button";

// attributes
export const ACTIVE = "active";
